import { render, staticRenderFns } from "./ChallengeCheckout.vue?vue&type=template&id=98dda21a"
import script from "./ChallengeCheckout.vue?vue&type=script&lang=js"
export * from "./ChallengeCheckout.vue?vue&type=script&lang=js"
import style0 from "./ChallengeCheckout.vue?vue&type=style&index=0&id=98dda21a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports